<template>
  <div class="my-area-menu">
    <div class="flex-middle">
      <div class="user-icon"></div>
      <div class="selected-item" v-on:click.stop="toggleDrop">{{ $nippets.my.myarea }}</div>
    </div>
    <transition name="fade">
      <div class="zoom-lightbox" v-show="viz" v-on:click="toggleDrop">
        <div class="selector"  v-on:click.stop="doNothing()">
          <div class="close-box small grey" v-on:click="toggleDrop"></div>
          <div class="mini-profile">
            <div class="user-image">
              <img :src="userImage" />
            </div>
            <div class="user-name">
              {{ fullname }}
            </div>
            <div class="user-company">
              {{ company }}
            </div>
          </div>
          <div class="ma-menu-item collections">
            <div class="ma-menu-dropper" :class="{expand: expand.collections}" v-on:click="expand.collections = !expand.collections">{{ $nippets.my.collections}}</div>
            <transition name="fade">
              <div class="ma-menu-expand" v-show="expand.collections" >
                <div class="ma-sub-item" :class="{sel: (folder.name === $store.state.profileFolder)}" v-for="(folder,index) in $store.state.profile.folders" v-on:click="goFolder(folder)" :key="'folder-' + index">
                  {{ folder.name }}
                </div>
              </div>
            </transition>
          </div>
          <ix-router-link to="/my-area/account" class="ma-menu-item user">{{ $nippets.my.account }}</ix-router-link>
          <div class="ma-menu-item logout" v-on:click="handleLogOut">{{ $nippets.my.logout}}</div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import authHandler from '@/auth-handler.js'

export default {
  data () {
    return {
      viz: false,
      expand: {
        collections: false
      },
      userImage: '',
      fullname: '',
      company: ''
    }
  },
  computed: {
    locKeys () {
      let keys = Object.keys(this.locs)
      keys.pop();
      return keys
    }
  },
  created () {
    this.init()
  },
  methods: {
    doNothing() {
      console.log('doing nothing')
    },
    goFolder(folder) {
      this.viz = false
      document.body.removeEventListener('click', this.closeDrop)
      this.$store.commit('setFolder', folder)
      this.$ixr.push('/my-area/collections/view')
    },
    toggleDrop () {
      this.viz = !this.viz
      if(!this.viz){
        document.body.removeEventListener('click', this.closeDrop)
      }
      else {
        document.body.addEventListener('click', this.closeDrop)
      }
    },
    closeDrop () {
      this.viz = false
      document.body.removeEventListener('click', this.closeDrop)
    },
    async handleLogOut () {
      await authHandler.handleSignOut()
      this.$k.messageBox(this.$nippets.my.logout, this.$nippets.yourSignedOut )
    },
    async init () {
      if(this.$store.state.profile) {
        const profile = this.$store.state.profile
        if(profile.avatar){
          this.userImage = this.$k.imagebase + 'images/users/' + profile.avatar
          
        }
        else {
          this.userImage = this.$k.imagebase + 'mediastore/img/user-large.svg'
        }
        this.fullname = profile.fullname
        this.company = profile.company
      }
      else {
        this.fullname = ''
        this.company = ''
        this.userImage = this.$k.imagebase + 'mediastore/img/user-large.svg'
      }
    }
  },
  watch: {
    '$store.state.profile': function () {
      this.init()
    },
    '$route.path': function () {
      this.viz = false
    }
  }
}
</script>

<style>

.my-area-menu{
  position:relative;
}


.my-area-menu .selected-item{
  background-image:url('../../assets/img/maindown.svg');
  background-position:center right;
  padding-right:17px;
  background-size:11px;
  cursor:pointer;
}

.my-area-menu .selected-item:hover{
  color:#ce0e2d;
  background-image:url('../../assets/img/maindown-red.svg');
}

.my-area-menu .selector{
  position:absolute;
  box-sizing:border-box;
  top:0;
  right:0;
  background-color:#fff;
  z-index:100;
  padding:25px 35px;
  border-bottom-left-radius: 8px;
}

.flex-middle{
  display:flex;
  align-items: center;
}

.my-area-menu .loc-item{
  padding:6px 12px;
}

.my-area-menu .loc-item:hover{
  background-color:#ce0e2d;
  color:#fff;
}

.my-area-menu .loc-item:hover a{
  color:#fff;
}

.ma-menu-item{
  background-position:left 10px;
  background-size:18px;
  padding:8px 8px 8px 26px;
  margin:12px 0;
  font-size:17px;
  line-height:24px;
  color:#101820;
  display:block;
}

.ma-menu-item:hover{
  color:#ce0e2d;
}

.user-icon{
  background-image:url('../../assets/img/user.svg');
  width:20px;
  height:1em;
}

.my-area-menu:hover .user-icon{
  background-image:url('../../assets/img/user-red.svg');
}

.ma-menu-item.router-link-exact-active{
  color:#ce0e2d;
}

.ma-menu-item.user{
  background-image:url('../../assets/img/user.svg');
}
.ma-menu-item.user:hover{
  background-image:url('../../assets/img/user-red.svg');
}
.ma-menu-item.logout{
  background-image:url('../../assets/img/logout.svg');
}
.ma-menu-item.logout:hover{
  background-image:url('../../assets/img/logout-red.svg');
}
.ma-menu-item.collections{
  background-image:url('../../assets/img/collections.svg');
}
.ma-menu-item.collections:hover{
  background-image:url('../../assets/img/collections-red.svg');
}

.ma-menu-dropper {
  padding-right:26px;
  background-image:url('../../assets/img/maindown.svg');
  background-position:right center;
  background-size:16px;
  margin-bottom:6px;
}

.ma-menu-dropper.expand{
  background-image:url('../../assets/img/mainup.svg');
}



.ma-menu-item:hover .ma-menu-dropper{
  background-image:url('../../assets/img/maindown-red.svg')
}

.ma-menu-item:hover .ma-menu-dropper.expand{
  background-image:url('../../assets/img/mainup-red.svg');
}

.ma-menu-expand{
  color:#101820;
  font-size:14px;
}

.ma-sub-item:hover{
  color:#ce0e2d;
}

.ma-sub-item.sel{
  font-weight:700;
}

.mini-profile .user-image{
  overflow:hidden;
  border-radius:50%;
  width:90px;
  height:90px;
}

.mini-profile .user-image img{
  height:100%;
}

.mini-profile .user-name{
  color:#101820;
  font-size:19px;
  margin-top:12px;
}

.mini-profile .user-company{
  font-size:17px;
  margin-top:8px;
}
</style>